import deDE from '../../../assets/images/languages/de-DE.png';
import enUS from '../../../assets/images/languages/en-US.png';
import enGB from '../../../assets/images/languages/en-GB.png';
import nlNL from '../../../assets/images/languages/nl-NL.png';
import frFR from '../../../assets/images/languages/fr-FR.png';
import itIT from '../../../assets/images/languages/it-IT.png';
import plPL from '../../../assets/images/languages/pl-PL.png';
import csCZ from '../../../assets/images/languages/cs-CZ.png';
import esES from '../../../assets/images/languages/es-ES.png';
import daDK from '../../../assets/images/languages/da-DK.png';
import lbLU from '../../../assets/images/languages/lb-LU.png';
import ruRU from '../../../assets/images/languages/ru-RU.png';
import srRS from '../../../assets/images/languages/sr-RS.png';
import hrHR from '../../../assets/images/languages/hr-HR.png';
import roRO from '../../../assets/images/languages/ro-RO.png';
import slSI from '../../../assets/images/languages/sl-SI.png';
import ukUA from '../../../assets/images/languages/uk-UA.png';
import deCH from '../../../assets/images/languages/de-CH.png';

export const LANGUAGES = {
  'de-DE': { name: 'Deutsch', flag: deDE, beta: false },
  'en-US': { name: 'English (US)', flag: enUS, beta: false },
  'en-GB': { name: 'English (UK)', flag: enGB, beta: false },
  'nl-NL': { name: 'Nederlands', flag: nlNL, beta: false },
  'fr-FR': { name: 'Français', flag: frFR, beta: false },
  'it-IT': { name: 'Italiano', flag: itIT, beta: false },
  'pl-PL': { name: 'Polski', flag: plPL, beta: false },
  'cs-CZ': { name: 'Čeština', flag: csCZ, beta: false },
  'es-ES': { name: 'Español', flag: esES, beta: false },
  'da-DK': { name: 'Dansk', flag: daDK, beta: false },
  'lb-LU': { name: 'Lëtzebuergesch', flag: lbLU, beta: true },
  'ru-RU': { name: 'Русский', flag: ruRU, beta: false },
  'sr-RS': { name: 'Српски', flag: srRS, beta: true },
  'hr-HR': { name: 'Hrvatski', flag: hrHR, beta: true },
  'ro-RO': { name: 'Română', flag: roRO, beta: false },
  'sl-SI': { name: 'Slovenščina', flag: slSI, beta: false },
  'uk-UA': { name: 'Українська', flag: ukUA, beta: false },
  'de-CH': { name: 'Schweizerdeutsch', flag: deCH, beta: false },
};
